export default {
  SET_COMPANIES: 'SET_COMPANIES',
  SET_MENU_ITEM_ID: 'SET_MENU_ITEM_ID',
  SET_MENU: 'SET_MENU',
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  SET_USER: 'SET_USER',
  SET_USER_LOGOUT: 'SET_USER_LOGOUT'
}
